export var TransportStatus;
(function (TransportStatus) {
    TransportStatus["NOT_CONNECTED"] = "NOT_CONNECTED";
    TransportStatus["CONNECTING"] = "CONNECTING";
    TransportStatus["CONNECTED"] = "CONNECTED";
    TransportStatus["SECONDARY_TAB_CONNECTED"] = "SECONDARY_TAB_CONNECTED";
})(TransportStatus || (TransportStatus = {}));
//# sourceMappingURL=TransportStatus.js.map